/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { FullScreenModal } from '.';
import { AlertBar } from './AlertBar';
import styled from 'styled-components';

const IframeAlertBar = styled(AlertBar)<AlertBar.Props>`
  position: absolute;
`;

export namespace IFrameModal {
  export interface Props {
    actionsComponent?: React.ReactNode;
    children?: React.ReactNode;
    error?: string | undefined;
    handleClose: () => void;
    id: string;
    subtitleComponent?: React.ReactNode;
    title: string;
    url: string;
  }
}

export const IFrameModal: React.FC<IFrameModal.Props> = ({
  id,
  url,
  handleClose,
  title,
  actionsComponent,
  subtitleComponent,
  error,
  children,
}) => {
  return (
    <FullScreenModal
      actionsComponent={actionsComponent}
      handleClose={handleClose}
      id={id}
      subtitleComponent={subtitleComponent}
      title={title}
    >
      {error && <IframeAlertBar errorMessage={error} id={id} />}
      <iframe height="100%" id={`${id}-iframe`} src={url} width="100%"></iframe>
      {children}
    </FullScreenModal>
  );
};
